import React, { useRef, useState } from 'react';
import { Link } from 'gatsby';
import ReCAPTCHA from 'react-google-recaptcha';

import '../../../styles/common/promos/newsletter-form.scss';

const NewsletterForm = (props) => {
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [nameError, setNameError] = useState(false);
	const [emailError, setEmailError] = useState(false);
	const [showCaptcha, setShowCaptcha] = useState(false);
	const [captchaChallenge, setCaptchaChallenge] = useState(false);
	
	const recaptchaRef = useRef();
	const hpRef = useRef();
	
	const clearForm = () => {
		recaptchaRef.current.reset();
		
		setNameError(false);
		setEmailError(false);
		setShowCaptcha(false);
		setCaptchaChallenge(false);
	};
	
	const onRecaptchaChange = (val) => {
		setShowCaptcha(false);
		setCaptchaChallenge(true);
	};
	
	const onSubmit = (e) => {
		// Validation
		if (!validates()) {
			e.preventDefault();
			return false;
		}
		
		// Honeypot
		if (hpRef.current.value.length > 0) {
			e.preventDefault();
			return false;
		}
		
		// Captcha Challenge
		if (!captchaChallenge) {
			setShowCaptcha(true);
			e.preventDefault();
			return false;
		}
		
		clearForm();
		return true;
	};
	
	const validates = () => {
		let validates = true;
		
		if (name.length === 0) {
			validates = false;
			setNameError(true);
		}
		
		if (email.length === 0) {
			validates = false;
			setEmailError(true);
		}
		
		return validates;
	};
	
	return (
		<div className={`newsletter-signup-form ${props.inlineCaptcha ? 'inline-captcha' : 'hover-captcha'}`}>
			<div className="links">
				<Link to="/privacy-policy">Privacy Policy</Link>{' '}
				<Link to="/subscribe">More Info</Link>
			</div>
    		<form action="https://sendy.publicdomainreview.org/subscribe" method="POST" acceptCharset="utf-8" target="_blank" rel="noopener noreferrer" onSubmit={ onSubmit }>
				<input type="text" name="name" id={`name-${props.formLocation}`} placeholder="Name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					className={nameError ? 'error' : ''}
				/>
				<input type="email" name="email" id={`email-${props.formLocation}`} placeholder="Email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					className={emailError ? 'error' : ''}
				/>
				<div style={{ display: 'none' }}>
					<label htmlFor="hp">HP</label>
					<input ref={hpRef} type="text" name="hp" id={`hp-${props.formLocation}`} />
				</div>
				<input type="hidden" name="list" value="XkP00J8byzLyvtQqu763obgA" />
				<input type="hidden" name="subform" value="yes" />
				<div
					className={`captcha-box ${showCaptcha ? 'expanded' : ''}`}
				>
					<ReCAPTCHA
						ref={ recaptchaRef }
						sitekey="6LdjWMQUAAAAAFOrGEhy7Nsmu7TG4TSbRIRDteex"
						onChange={ onRecaptchaChange }
						size={props.inlineCaptcha ? null : 'compact'}
					/>
				</div>
				<input type="submit" name="submit" id={`submit-${props.formLocation}`} value="Subscribe" />
			</form>
		</div>
	);
};

export default NewsletterForm;